package music.jammers.client.shared.signin

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import dev.gitlive.firebase.auth.externals.GoogleAuthProvider
import dev.gitlive.firebase.auth.externals.getAuth
import dev.gitlive.firebase.auth.externals.signInWithPopup
import dev.gitlive.firebase.externals.initializeApp
import music.jammers.client.shared.signin.models.AuthResponse
import music.jammers.client.shared.signin.models.GoogleAuthError
import org.jetbrains.compose.resources.DrawableResource

internal actual val GOOGLE_ACCESS_TOKEN: String? = ""

@Composable
internal actual fun GoogleLoginButton(
    onResponse: (AuthResponse) -> Unit,
    progress: Boolean,
    iconDrawable: DrawableResource,
    modifier: Modifier,
) {

    GoogleButtonUI(
        modifier = modifier,
        onClick = { googleLogin(onResponse) },
        progress = progress,
        iconDrawable = iconDrawable,
    )
}

private fun googleLogin(
    onLoggedIn: (AuthResponse) -> Unit,
) {
    onLoggedIn(AuthResponse.Progress)

    val firebaseConfig: dynamic = object {}
    firebaseConfig["apiKey"] = "AIzaSyD5F3-IAaVlBwuYn_WAUpaqK9JlapYeV2c"
    firebaseConfig["authDomain"] = "limasoul-8c30d.firebaseapp.com"
    firebaseConfig["projectId"] = "limasoul-8c30d"
    firebaseConfig["storageBucket"] = "limasoul-8c30d.firebasestorage.app"
    firebaseConfig["messagingSenderId"] = "1010906947053"
    firebaseConfig["appId"] = "1:1010906947053:web:94a96fa8c18a563f515be4"
    firebaseConfig["measurementId"] = "G-0W1GSQ4BXG"

    val firebaseApp = initializeApp(firebaseConfig)

    val auth = getAuth(firebaseApp)

    val provider = GoogleAuthProvider()
    provider.addScope("https://www.googleapis.com/auth/plus.login")

    signInWithPopup(auth, provider).then { result ->
        println("Login success. Taking tokent")
        println("User: ${result.user.displayName}")

        result.user.getIdTokenResult(false).then { idTokenResult ->
            onLoggedIn(
                AuthResponse.Success(TOKEN_NOT_REQUIRED)
            )
        }.catch { throwable ->
            onLoggedIn(
                AuthResponse.Error(
                    GoogleAuthError(-1, throwable.message ?: "Firebase error")
                )
            )
        }
    }.catch { throwable ->
        onLoggedIn(
            AuthResponse.Error(
                GoogleAuthError(-1, throwable.message ?: "Firebase error")
            )
        )
    }
}